import React, { Fragment } from 'react';

const TrafficCountingPointTooltip = ({ objectToDisplay, pointerX, pointerY }) => {
  console.log(objectToDisplay);
  return (
    <div style={{ position: 'absolute', zIndex: 3, pointerEvents: 'none', left: pointerX + 20, top: pointerY, ...styles.tooltipContainer }}>
      <span style={styles.title}>{objectToDisplay.name}</span><br />
      {objectToDisplay.description &&
        <Fragment>
          <span style={styles.description}>{objectToDisplay.description}</span><br />
        </Fragment>
      }
      <span style={styles.date}>Bắt đầu đo: {objectToDisplay.from_date_formatted}</span><br />
      <span style={styles.date}>Kết thúc đo: {objectToDisplay.to_date_formatted}</span><br />
      <div>
        <span style={styles.resultHeading}>Kết quả đo: {objectToDisplay.total_vehicles}</span><br />
        <ul>
        {objectToDisplay.results.map((result, index) =>
          <li style={styles.resultLine} key={index}>
            <span style={styles.resulTypeOfVehicle}>{result.name}</span>
            {`: ${result.number_of_vehicles}`}
          </li>  
        )}
        </ul>
      </div>
    </div>
  );
}

const styles = {
  tooltipContainer: {
    backgroundColor: 'var(--color-white)',
    padding: 12,
    boxShadow: '0 2px 4px 0 rgba(0,0,0,.24)',
    borderRadius: 4,
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
  },
  description: {
    fontSize: 14,
    whiteSpace: 'pre-line',
  },
  resultLine: {
    fontSize: 14,
  },
  resulTypeOfVehicle: {
    fontWeight: 500,
  },
  date: {
    color: 'var(--color-muted)',
  },
}

export default TrafficCountingPointTooltip;